import BarChartIcon from "@mui/icons-material/BarChart";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import PieChartIcon from "@mui/icons-material/PieChart";
import { Box, List } from "@mui/material";
import React from "react";
import { Droppable } from "react-beautiful-dnd";
import { AppChartType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { TaskTypeDialogChartDesignerDroppableId } from "../../FormDesignerTypes";
import { ChartDesignerChartPickerItem, getRenderItem, IChartDesignerChartPickerItemProps } from "./ChartDesignerChartPickerItem";

export const getChartNameForNewIntance = (names: string[], taskChartType: AppChartType) => {
    const nameBase = AppChartType[taskChartType];
    let index = 1;
    while (names.find(item => item === nameBase + index) !== undefined) {
        index += 1;
    }
    return nameBase + index;
};

export const getChartTitleForNewIntance = (titles: string[], taskChartType: AppChartType) => {
    const titleBase = AppChartType[taskChartType];
    let index = 1;
    while (titles.find(item => item === titleBase + " " + index) !== undefined) {
        index += 1;
    }
    return titleBase + " " + index;
};

const pickerItems: IChartDesignerChartPickerItemProps[] = [
    {
        taskChartType: AppChartType.BarChart,
        title: Translations.BarChart,
        icon: <BarChartIcon />,
        index: 0
    },
    {
        taskChartType: AppChartType.LineChart,
        title: Translations.LineChart,
        icon: <ShowChartIcon />,
        index: 1
    },
    {
        taskChartType: AppChartType.PieChart,
        title: Translations.PieChart,
        icon: <PieChartIcon />,
        index: 2
    },
];

export const ChartDesignerChartPicker = () => {
    const renderItems = getRenderItem(pickerItems);

    return (
        <DialogSectionCard headerTitle={Translations.Charts} contentPadding="16px 0 16px 16px!important">
            <Droppable
                isDropDisabled
                droppableId={TaskTypeDialogChartDesignerDroppableId.Picker}
                renderClone={renderItems}
            >
                {(provided, _snapshot) => (
                    
                    <Box
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        sx={{
                            position: "relative",
                            height: "calc(100vh - 350px)",
                            overflow: "auto",
                            paddingRight: "16px"
                        }}
                    >
                        {/* <Typography variant="caption" color="text.secondary">{Translations.SimpleCharts}</Typography> */}
                        <List>
                            {pickerItems.map((item) => (
                                <ChartDesignerChartPickerItem key={item.index} {...item} />
                            ))}
                        </List>
                        {provided.placeholder}
                    </Box>
                )}
            </Droppable>
        </DialogSectionCard>
    );
};
